import React from 'react';
import clsx from 'clsx';
import Box from '@mui/material/Box';
import ScrollBox from '@erikdakoda/ui/components/ScrollBox';

type SelfScrollingArtifactFrameProps = {
  className?: string;
  children: React.ReactNode;

  /**
   * When false, children fill the panel cell directly (iframe types scroll inside the frame).
   * When true, wraps children in ScrollBox (markdown and plain text).
   */
  useScrollBox?: boolean;
};

/**
 * Full-height panel shell so each artifact type owns scrolling (ScrollBox or iframe).
 */
export default function SelfScrollingArtifactFrame({
  className,
  children,
  useScrollBox = true,
}: SelfScrollingArtifactFrameProps): React.ReactElement {
  'use memo';

  return (
    <Box
      className={clsx('self-scrolling-artifact-frame', className)}
      sx={{
        height: '100%',
        minHeight: 0,
        minWidth: 0,
        overflow: 'hidden',
        display: 'grid',
        gridTemplateRows: '1fr',
      }}
    >
      {useScrollBox ? <ScrollBox>{children}</ScrollBox> : children}
    </Box>
  );
}
